<template>
    <div class="container" :class="{'rtl' : this.language === 'fa' }">
        <div class="row justify-content-center">
            <div class="col-12 col-md-9 col-lg-8 sections all-box-shadows p-0" id="me">
                <nav id="main-nav-bar" class="navbar navbar-expand-xl navbar-light sticky-top">
                    <button class="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#nav-bar-main" aria-controls="nav-bar-main" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="navbar-brand choose-language-icons">
                        <vs-button class="d-inline theme-toggle" icon border @click="toggleTheme"
                                   :title="themeLabel" :aria-label="themeLabel">
                            <i :class="isDark ? 'bx bx-sun' : 'bx bx-moon'"></i>
                        </vs-button>
                        <vs-button class="d-inline" icon border :active="language === 'fa'" @click="changeLocale('fa')">
                            FA
                        </vs-button>
                        <vs-button class="d-inline" icon border :active="language === 'en'" @click="changeLocale('en')">
                            EN
                        </vs-button>
                    </div>
                    <div class="collapse navbar-collapse" id="nav-bar-main">
                        <ul class="navbar-nav mt-2 mt-lg-0 text-center p-0">
                            <li class="nav-item">
                                <a class="nav-link" href="#me"> {{ $t("me") }} </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#experience"> {{ $t("experience") }} </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#education"> {{ $t("education") }} </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#skill"> {{ $t("skill") }} </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#project"> {{ $t("project") }} </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#achievement"> {{ $t("achievement") }} </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#contact"> {{ $t("contact") }} </a>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="row justify-content-center header pt-4 pb-3 m-0">
                    <div class="col-11 col-sm-8 col-md-7 col-lg-6">
                        <div class="about-section">
                            <vs-avatar class="logo all-box-shadows" size="90" badge badge-color="success">
                                <img src="@/assets/images/me.png" alt="Abolfazl Mohajeri" width="90" height="90">
                                <template #badge>
                                    <br>
                                </template>
                            </vs-avatar>
                            <h1 class="name-mark all-box-shadows">
                                <span class="d-block"> {{ $t("abolfazl") }} </span>
                                <span class="d-block"> {{ $t("mohajeri") }} </span>
                            </h1>
                        </div>
                        <h4 class="mt-3 mb-1 text-center"> {{ $t("senior_software_engineer") }} </h4>
                        <div class="my-2 text-center">
                            <vs-button class="d-inline social-btn iconic-btn" href="https://www.linkedin.com/in/abmohajeri" blank icon>
                                <i class='bx bxl-linkedin'></i>
                            </vs-button>
                            <vs-button class="d-inline social-btn iconic-btn" href="https://github.com/abmohajeri" blank icon>
                                <i class='bx bxl-github'></i>
                            </vs-button>
                            <vs-button class="d-inline social-btn iconic-btn" href="https://stackoverflow.com/users/8495783/abolfazl-mohajeri" blank icon>
                                <i class='bx bxl-stack-overflow'></i>
                            </vs-button>
                            <vs-button class="d-inline social-btn iconic-btn" href="https://t.me/abmohajeri" blank icon>
                                <i class='bx bxl-telegram'></i>
                            </vs-button>
                            <vs-button class="d-inline social-btn iconic-btn" href="https://www.instagram.com/abmohajeri" blank icon>
                                <i class='bx bxl-instagram'></i>
                            </vs-button>
                        </div>
                    </div>
                </div>
                <About></About>
                <Experience id="experience"></Experience>
                <Education id="education"></Education>
                <Skill id="skill"></Skill>
                <Project id="project"></Project>
                <Achievement id="achievement"></Achievement>
                <Contact id="contact"></Contact>
                <Footer></Footer>
            </div>
        </div>
    </div>
</template>

<script>
import About from "../../components/About";
import Experience from "../../components/Experience";
import Education from "../../components/Education";
import Skill from "../../components/Skill.vue";
import Project from "../../components/Project.vue";
import Achievement from "../../components/Achievement";
import Contact from "../../components/Contact";
import Footer from "../../components/Footer";
import $ from 'jquery';
import { themeState, toggleTheme } from "../../theme";

export default {
        name: "Index",
        components: {
            About,
            Experience,
            Education,
            Skill,
            Project,
            Achievement,
            Contact,
            Footer
        },
        computed: {
            language() {
                return this.$i18n.locale;
            },
            isDark() {
                return themeState.theme === 'dark';
            },
            themeLabel() {
                return this.isDark ? this.$t('light_mode') : this.$t('dark_mode');
            }
        },
        mounted() {
            $("#nav-bar-main a.nav-link").on("click", function (e) {
                e.preventDefault();
                let myElement = document.getElementById($(this).attr("href").slice(1));
                if (!myElement) return;
                let topPos = myElement.offsetTop;
                window.scrollTo({
                    top: topPos - 50,
                    behavior: "smooth"
                });
            });
        },
        methods : {
            toggleTheme,
            changeLocale: function(lang) {
                if(this.language !== lang) {
                    this.$router.push('/' + lang);
                }
            }
        }
    }
</script>

<style>

</style>

<style scoped>

</style>
